<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search>
      </report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增车辆类型' : '编辑车辆类型'"
      width="800"
      ref="formModel"
    >
      <alot-item
        @on-click="openForm = true"
        slot="ono"
        v-model="item.listOrders"
        keyw="name"
      ></alot-item>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <Drawer v-model="openDrawer" width='100%'>
      <adds ref="adds"></adds>
    </Drawer>
  </div>
</template>
<script>
var categorys = [];
import adds from "./adds"
export default {
  components:{adds},
  data() {
    return {
      isAdd: false,
      openDrawer:false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "所属单位",
          key: "groupName",
          sort: 10,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        name: "",
        remark: "",
        listOrders: [
          {
            name: "起：万达广场",
            x: 114.12,
            y: 22.65,
          },
          {
            name: "经：木古地铁站",
            x: 114.12,
            y: 22.65,
          },
          {
            name: "经：上李朗地铁站",
            x: 114.122,
            y: 22.653,
          },
          {
            name: "终：建昇大厦",
            x: 114.124,
            y: 22.656,
          },
        ],
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        /* {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        }, */
      ],
      total: 0,
      categorys: [],
      forms: [
        {
          title: "名称",
          key: "name",
          multiple: true,
          type: "Input",
          required: true,
        },
        {
          title: "起点",
          key: "name",
          multiple: true,
          type: "Input",
        },
        {
          title: "途径点",
          key: "ono",
          slotForm: "ono",
          required: true,
          span: 24,
        },
      ],
    };
  },
  methods: {
    getList() {

      return;
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dm + "/carType/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.dm + "/carType/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.dm + "/carType/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.dm + "/carType/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      //this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.openDrawer=true;
      this.$refs.adds.reach(this.item.listOrders)
      //this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory
    getDictionary() {
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "carTypeCategory",
        },
      }).then((res) => {
        var a = JSON.parse(res.data.data.value);
        categorys.splice(0, 100);
        for (const i in a) {
          categorys.push(a[i].name);
        }
      });
    },
    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
    this.getDictionary();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/paisong/paisongluxian.vue